import { Header } from 'components/Header'
import Footer from 'components/Footer'
import { Layout } from 'types/careguide-page'

const PageLayout: Layout = ({ children, loggedIn, hasFooter, hasUpgradeCta }) => (
  <>
    <Header loggedIn={!!loggedIn} showUpgradeCta={!!hasUpgradeCta} />
    <main>{children}</main>
    {hasFooter && <Footer />}
  </>
)

export default PageLayout
